export const versionDev: string = '1.3.0';
export const versionQas: string = '1.3.0';
export const versionStage: string = '1.2.1';
export const versionProd: string = '1.2.1';

export const rc: number = 1;
